import {
  cycleCountIdFormat,
  productIdFormat,
} from "@redotech/redo-ids-cockroach";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const addCycleCountLines = unaryRpc({
  name: "addCycleCountLines" as const,
  input: z.object({
    id: cycleCountIdFormat.schema,
    productIds: z.array(productIdFormat.schema).min(1).max(500),
  }),
  output: z.object({ addedCount: z.int() }),
});
